"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
var _SelectedItem = _interopRequireDefault(require("./SelectedItem.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SelectedItem = function SelectedItem(props) {
  return /*#__PURE__*/_react["default"].createElement(_SelectedItem["default"], {
    className: "selected-item-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: "selected-item-icon",
    icon: "ion-android-delete",
    size: 14,
    onClick: function onClick() {
      return props.onRemove(props.value);
    },
    "aria-label": "Remove item"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "selected-item-value"
  }, props.children));
};
SelectedItem.propTypes = {
  children: _propTypes["default"].node.isRequired,
  onRemove: _propTypes["default"].func.isRequired,
  value: _propTypes["default"].oneOfType([_propTypes["default"].shape({
    value: _propTypes["default"].string,
    label: _propTypes["default"].string
  }), _propTypes["default"].string]).isRequired
};
var _default = exports["default"] = SelectedItem;